import store from "../store";
import { actionTypes } from "./saga";

/**
 * @module ProceduresSaga
 */

/**
 *
 * @param {object} data
 */
export function putProceduresData(data) {
  store.dispatch({
    type: actionTypes.ADD_PROCEDURES_DATA,
    payload: {
      data: data
    }
  });
}

/**
 *
 * @param {object} locationId
 */
export function getProceduresAssets(locationId, selectedProcedure, index) {
  store.dispatch({
    type: actionTypes.GET_PROCEDURES_ASSETS,
    payload: {
      locationId: locationId,
      selectedProcedure: selectedProcedure,
      index: index
    }
  });
}

/**
 *
 * @param {object} data
 */
export function setSelectedProcedure(data) {
  store.dispatch({
    type: actionTypes.ADD_SELECTED_PROCEDURE,
    payload: {
      data: data
    }
  });
}

/**
 *
 * @param {object} data
 */
export function createProcedurePreset(data, navigate) {
  store.dispatch({
    type: actionTypes.CREATE_PROCEDURE_PRESET,
    payload: {
      data,
      navigate
    }
  });
}

/**
 *
 * @param {object} data
 */
export function editProcedurePreset(data, navigate) {
  store.dispatch({
    type: actionTypes.EDIT_PROCEDURE_PRESET,
    payload: {
      data,
      navigate
    }
  });
}

export function setProceduresExportLoading(data) {
  store.dispatch({
    type: actionTypes.PUT_PROCEDURES_EXPORT_LOADING,
    payload: { loading: data }
  });
}
